/* eslint-disable */
/**
 * Web Sequence Analyzer (WSA)
 * API serving data for the Web Sequence Analyzer (WSA)
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  OpenFileRequest,
  OpenFileResponse,
  SessionResponse,
} from '../models/index';
import {
    OpenFileRequestFromJSON,
    OpenFileRequestToJSON,
    OpenFileResponseFromJSON,
    OpenFileResponseToJSON,
    SessionResponseFromJSON,
    SessionResponseToJSON,
} from '../models/index';

export interface SequenceAnalyzerSessionRequest {
    seqAnalSessionId: string;
}

export interface UploadFileRequest {
    seqAnalSessionId: string;
    openFileRequest?: OpenFileRequest;
}

/**
 * 
 */
export class SessionApi extends runtime.BaseAPI {

    /**
     * Find WSA session with the given ID
     * Obtain session with the given ID
     */
    async sequenceAnalyzerSessionRaw(requestParameters: SequenceAnalyzerSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SessionResponse>> {
        if (requestParameters.seqAnalSessionId === null || requestParameters.seqAnalSessionId === undefined) {
            throw new runtime.RequiredError('seqAnalSessionId','Required parameter requestParameters.seqAnalSessionId was null or undefined when calling sequenceAnalyzerSession.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/sequenceAnalyzer/session/{seqAnalSessionId}`.replace(`{${"seqAnalSessionId"}}`, encodeURIComponent(String(requestParameters.seqAnalSessionId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SessionResponseFromJSON(jsonValue));
    }

    /**
     * Find WSA session with the given ID
     * Obtain session with the given ID
     */
    async sequenceAnalyzerSession(requestParameters: SequenceAnalyzerSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SessionResponse> {
        const response = await this.sequenceAnalyzerSessionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Read sequences from uploaded Fasta file and add them to Session
     * Add sequences to session
     */
    async uploadFileRaw(requestParameters: UploadFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OpenFileResponse>> {
        if (requestParameters.seqAnalSessionId === null || requestParameters.seqAnalSessionId === undefined) {
            throw new runtime.RequiredError('seqAnalSessionId','Required parameter requestParameters.seqAnalSessionId was null or undefined when calling uploadFile.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/sequenceAnalyzer/session/{seqAnalSessionId}/sequences`.replace(`{${"seqAnalSessionId"}}`, encodeURIComponent(String(requestParameters.seqAnalSessionId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OpenFileRequestToJSON(requestParameters.openFileRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OpenFileResponseFromJSON(jsonValue));
    }

    /**
     * Read sequences from uploaded Fasta file and add them to Session
     * Add sequences to session
     */
    async uploadFile(requestParameters: UploadFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OpenFileResponse> {
        const response = await this.uploadFileRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
